/**
 * @returns {*}
 */
function ipv4 () {
  return /^((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])$/
}

module.exports = { ipv4 }
